import React from 'react'

const Package = () => {
    return (
        <div>
            <div className="page-header"></div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                    <div className="card">
                        <div className="card-header">
                            <h3 className="card-title text-color-3" style={{ fontWeight: "200", fontSize: "22px" }}>Package</h3>
                        </div>
                        <div className="card-body" style={{ display: "flex", flexDirection: "row", justifyContent: "space-around",flexWrap:'wrap' }}>
                            <div style={{marginTop:20}}>
                                <img src={require("../assets/images/brand/grocery.jpg")} height={300} />
                            </div>
                            <div style={{marginTop:20}}>
                                <img src={require("../assets/images/brand/garments.jpg")} height={300} />
                            </div>
                            <div style={{marginTop:20}}>
                                <img src={require("../assets/images/brand/garments1500.jpeg")} height={200} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >

    )
}

export default Package